import { generateId } from '@freelancer/datastore/testing';
import { Enterprise } from '../enterprise/enterprise.model';
import { EnterpriseModel } from './enterprises.model';

export interface GenerateEnterpriseOptions {
  readonly id?: number;
  readonly internalName: string;
  readonly name: string;
  readonly seoUrl: string;
  readonly isTestEnterprise?: boolean;
  readonly dateCreated?: number;
  readonly description?: string;
  readonly landingPageUrl?: string;
  readonly logoFileId?: string;
  readonly avatarFileId?: string;
}

export function generateEnterpriseObject({
  id,
  internalName,
  name,
  seoUrl,
  isTestEnterprise = false,
  dateCreated = Date.now(),
  description,
  landingPageUrl,
  logoFileId,
  avatarFileId,
}: GenerateEnterpriseOptions): EnterpriseModel {
  return {
    id: id || generateId(),
    internalName,
    name,
    seoUrl,
    isTestEnterprise,
    dateCreated,
    description,
    landingPageUrl,
    logoFileId,
    avatarFileId,
  };
}

export function generateEnterpriseObjects(
  enterpriseOptionsList: readonly GenerateEnterpriseOptions[],
): readonly EnterpriseModel[] {
  return enterpriseOptionsList.map(enterpriseOptions =>
    generateEnterpriseObject(enterpriseOptions),
  );
}

export function facebookEnterprise(): GenerateEnterpriseOptions {
  return {
    id: Enterprise.FACEBOOK,
    internalName: 'facebook',
    seoUrl: 'facebook',
    name: 'Facebook',
    description: 'Facebook is a Social Network.',
    landingPageUrl: 'https://facebook.example',
    logoFileId: 'uuid-logo',
    avatarFileId: 'uuid-avatar',
  };
}
